/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_EmailInputs */

const en_admin_settings_tabs_email = /** @type {(inputs: Admin_Settings_Tabs_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_admin_settings_tabs_email = /** @type {(inputs: Admin_Settings_Tabs_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮件`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Admin_Settings_Tabs_EmailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_email = /** @type {((inputs?: Admin_Settings_Tabs_EmailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_EmailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_email(inputs)
	return zh_admin_settings_tabs_email(inputs)
});
export { admin_settings_tabs_email as "admin.settings.tabs.email" }